var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", [
    _c(
      "div",
      { class: { "fixed-header": _vm.fixedHeader, "hok-header": true } },
      [
        _c("HokLogo"),
        _c("HokTopMenu"),
        _c("Product"),
        _c("HokNotice"),
        _c("HokNavbar"),
        _vm.needTagsView ? _c("HokOperate") : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }